import * as React from "react"
import { Box, IconButton } from "@chakra-ui/react"
import { FiChevronsLeft, FiSidebar } from "react-icons/fi"
import { SIDEBAR_WIDTH, TOPBAR_HEIGHT } from "../lib/config"
import { useStoredDisclosure } from "../lib/hooks/useStoredDisclosure"
import MapStyleControl from "./MapStyleControl"

interface Props {
  children: React.ReactNode
  sidebarKey: string
  styleControl?: boolean
}

export const Sidebar = (props: Props) => {
  const sidebarProps = useStoredDisclosure({ key: props.sidebarKey, defaultIsOpen: true })
  return (
    <>
      <Box pos="absolute" h={sidebarProps.isOpen ? `calc(100vh - ${TOPBAR_HEIGHT})` : "auto"} zIndex={10}>
        <Box
          display={sidebarProps.isOpen ? "block" : "none"}
          w={SIDEBAR_WIDTH}
          bg="white"
          borderTopLeftRadius={0}
          borderBottomLeftRadius={0}
          h="100%"
          overflow="hidden"
        >
          {/* <Box
          position="absolute"
          top={0}
          right="-30px"
          bg="radial-gradient(circle at bottom right, transparent 30px, #fff 30px)"
          boxSize="30px"
        />
        <Box
        position="absolute"
          bottom={0}
          right="-30px"
          bg="radial-gradient(circle at top right, transparent 30px, #fff 30px)"
          boxSize="30px"
        /> */}

          {props.children}
          <IconButton
            position="absolute"
            top={4}
            right={4}
            variant="ghost"
            zIndex={100}
            size="sm"
            onClick={sidebarProps.onClose}
            aria-label="close sidebar"
            icon={<FiChevronsLeft />}
          />
        </Box>
        {!sidebarProps.isOpen && (
          <Box p={4}>
            <IconButton
              size="sm"
              bg="white"
              _hover={{ bg: "gray.100" }}
              onClick={sidebarProps.onOpen}
              aria-label="open sidebar"
              icon={<FiSidebar />}
              boxShadow="lg"
            />
          </Box>
        )}
      </Box>
      {props.styleControl && (
        <Box
          position="absolute"
          bottom={4}
          left={sidebarProps.isOpen ? `calc(${SIDEBAR_WIDTH}px + 1rem)` : "1rem"}
        >
          <MapStyleControl />
        </Box>
      )}
    </>
  )
}
